export const useLocale = (locale?: string | null) => {
  switch (locale) {
    case 'us':
      return {
        units: {
          weight: 'lb',
          dimension: 'ft'
        },
        currency: {
          name: 'Dollar',
          symbol: '$'
        }
      }
    default:
    case 'uk':
      return {
        units: {
          weight: 'kg',
          dimension: 'm'
        },
        currency: {
          name: 'Pound',
          symbol: '£'
        }
      }
  }
}
